import { settingsConstants } from '../constants';
import { settingsService } from '../../services';

export const settingsActions = {
  getSettings,
  updateSettings
}

/*
ACTION: Get Settings
*/
function getSettings(addToast) {
  return dispatch => {
    dispatch(request());
    return settingsService.getSettings()
      .then(
        response => {
          dispatch(success(response.data.body.settings));
        },
        error => {
          if (typeof error === 'object' && addToast) {
            Object.keys(error).map((key) => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: settingsConstants.GET_REQUEST } }
  function success(items) { return { type: settingsConstants.GET_SUCCESS, items } }
  function failure(error) { return { type: settingsConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Settings
*/
function updateSettings(addToast, formData) {
  return dispatch => {
    dispatch(request());
    formData.map(formDataGroup => {
      return settingsService.updateSettings(formDataGroup)
      .then(
        {},
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
    })
    addToast('تنظیمات با موفقیت بروزرسانی انجام شد.', { appearance: "success", autoDismiss: true });
    dispatch(success(true));
  }

  function request() { return { type: settingsConstants.UPDATE_REQUEST } }
  function success(status) { return { type: settingsConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: settingsConstants.UPDATE_FAILURE, error } }
}